import { useMutation } from '@tanstack/react-query';
import { post } from '../libs';

interface Payload {
  /** 공지사항 제목 */
  title: string;
  /** 공지사항 내용 */
  body: string;
}

/**
 * 헬스장 관리자 - 헬스장 공지사항 등록
 * @link https://api-dev.fibud.kr/api#/%ED%97%AC%EC%8A%A4%EC%9E%A5%20%EA%B4%80%EB%A6%AC%EC%9E%90/GymAdminsController_createGymNotice
 * @param param0
 * @returns
 */
export default function usePostNoticeMutation() {
  return useMutation((payload: Payload) =>
    post<string, Payload>('/gym-admins/notice', payload)
  );
}
